/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum DocumentTypesEnum {
  Identification = 1,
  IncomeVerification = 2,
  AssistanceVerification = 3,
  LeaseApplication = 4,
  LeaseAgreement = 40,
  Image = 37,
  License = 48,
  Insurance = 49,
  Receipt = 50,
  BeforeImage = 51,
  AfterImage = 52,
  Other = 999,
}
